import { LocalTimeRange } from '@ftr/contracts/type/shared'
import { DateFormat, jodaFormatPatternWithLocale } from '@ftr/foundation'
import { LocalTime } from '@js-joda/core'

/**
 * LocalTimeRange requires an end time, so we use one second before midnight as a proxy for "no end time" i.e. ongoing.
 *
 * The const is defined to the second, rather than using `LocalTime.MAX` directly which is nanosecond precise.
 * This is to be consistent with other parts of the app, and to be compatible with times that are serialized
 * when written to the DB (millisecond precise).
 *
 * @see {@link LocalTimeRange} toPostgresTimerange
 */
export const ONGOING_END_TIME_PROXY = LocalTime.MAX.withNano(0)

export const REQUEST_TIME_FORMAT = jodaFormatPatternWithLocale(DateFormat.TimeWithSeconds)

export function isOngoingEnd(endTime: LocalTime | null | undefined): boolean {
  if (!endTime) return false
  return !endTime.isBefore(ONGOING_END_TIME_PROXY)
}

export function formatRequestTimeRange(timeRange: LocalTimeRange): string {
  return `${timeRange.start.format(REQUEST_TIME_FORMAT)} - ${isOngoingEnd(timeRange.end) ? 'Ongoing' : timeRange.end.format(REQUEST_TIME_FORMAT)}`
}
